import { render, staticRenderFns } from "./icare_people_without_icare.vue?vue&type=template&id=3a41334b&scoped=true&"
import script from "./icare_people_without_icare.vue?vue&type=script&lang=js&"
export * from "./icare_people_without_icare.vue?vue&type=script&lang=js&"
import style0 from "./icare_people_without_icare.vue?vue&type=style&index=0&id=3a41334b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a41334b",
  null
  
)

export default component.exports